export default "__VITE_ASSET__jQNCxJ1J__"